module.exports = __webpack_public_path__ + "static/media/Form_Continue_Button@2x.817a5e3e.png";